import React, { useState, useEffect, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { ThemeContext } from "styled-components";
import Modal from "../../UI/PopupModal";
import { FullRefIcon, PlaceHolder } from "./assets";
import { fetchPassage } from "../../../api/BibleApi";
import { chapterPath } from "../../../utils/paths";

const ScriptureRefModal = ({ bibleId, refId, onClose, location }) => {
  const [passage, setPassage] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const theme = useContext(ThemeContext);

  useEffect(() => {
    const fetchPreviewRef = async () => {
      setLoading(true);

      try {
        const message = await fetchPassage({
          bibleId,
          passageId: refId
        });
        const { reference, content } = message;
        setPassage({ reference, content: content.trim() });
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(err);
        setLoading(true);
      }
    };

    fetchPreviewRef();
  }, [bibleId, refId]);

  const refLink = chapterPath({
    bibleId,
    chapterId: refId
      .split(".")
      .slice(0, 2)
      .join("."),
    location,
    passageId: refId
  });

  const footer = (
    <Link to={refLink}>
      <FullRefIcon fill={theme.primaryText} />
    </Link>
  );

  if (isError || isLoading)
    return (
      <Modal onClose={onClose} footer={footer}>
        <PlaceHolder isError={isError} />
      </Modal>
    );

  const { reference, content } = passage;
  return (
    <Modal title={reference} footer={footer} onClose={onClose}>
      {content}
    </Modal>
  );
};

ScriptureRefModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  bibleId: PropTypes.string.isRequired,
  refId: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(ScriptureRefModal);
